<template>
  <v-card
    :style="
      border
        ? 'border-left:10px solid ' + color + '; webkit-box-shadow: 0px 0px 7px 5px rgb(231, 230, 230); height: 100%'
        : 'webkit-box-shadow: 0px 0px 7px 5px rgb(231, 230, 230);'
    "
    class="pa-3 flat"
  >
    <v-row>
      <v-col cols="2" :md="mdIcon" :lg="lgIcon" :xl="xlIcon" class="text-center py-auto px-2">
        <v-img v-if="logo" :src="logo"></v-img>
        <v-icon v-else large :color="color">{{ icon }}</v-icon>
      </v-col>
      <v-col cols="10" :md="mdInfo" :lg="lgInfo" :xl="xlInfo">
        <p class="ma-0">{{ title }}</p>
        <p v-if="info" :class="'ma-0'" :style="border ? 'color:' + color : ''" v-html="info"></p>
        <m-button dark :color="color" class="my-2" v-else small depreed :textButton="textButton" action="toAction" @toAction="$emit(emitButton)"></m-button>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
// @group Global Component
export default {
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      default: "Info"
    },
    info: {
      type: String,
      default: null
    },
    textButton: {
      type: String,
      default: "Cek disini"
    },
    emitButton: {
      type: String,
      default: null
    },
    logo: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: "#007bff"
    },
    icon: {
      type: String,
      default: "mdi-information"
    },
    border: {
      type: Boolean,
      default: false
    },
    mdIcon: {
      type: Number,
      default: 2
    },
    lgIcon: {
      type: Number,
      default: 2
    },
    xlIcon: {
      type: Number,
      default: 2
    },
    mdInfo: {
      type: Number,
      default: 10
    },
    lgInfo: {
      type: Number,
      default: 10
    },
    xlInfo: {
      type: Number,
      default: 10
    }
  },
  computed: {}
};
</script>

<style></style>
